export default class SelectOption {

    public value: string;
    public label: string;

    constructor(data: { [key: string]: any }) {
        this.value = data['value'];
        this.label = data['label'];
    }
}